interface ProjectProps {
  value?: number;
  name?: string;
  description?: string;
  query?: string;
  color?: string;
  selected?: boolean;
  tooltip?: string;
  label?: string;
  shared?: boolean;
  userId?: number;
  userName?: string;
  accountId?: number;
  accountName?: string;
}

export class Project {
  public value?: number;
  public name?: string;
  public description?: string;
  public query?: string;
  public color?: string;
  public selected?: boolean;
  public tooltip?: string;
  public label?: string;
  public shared?: boolean;
  public userId?: number;
  public userName?: string;
  public accountId?: number;
  public accountName?: string;

  constructor({
    value,
    name,
    description,
    query,
    color,
    selected,
    tooltip,
    label,
    shared,
    userId,
    userName,
    accountId,
    accountName,
  }: ProjectProps) {
    this.value = value || null;
    this.name = name || null;
    this.description = description || null;
    this.query = query || null;
    this.color = color || null;
    this.selected = selected || false;
    this.tooltip = tooltip || null;
    this.label = label || null;
    this.shared = shared !== undefined ? shared : true;
    this.userId = userId || null;
    this.userName = userName || null;
    this.accountId = accountId || null;
    this.accountName = accountName || null;
  }
}
